<template>
  <div class="check-in-phone">
    <div class="check-in-phone__input">
      <span v-if="phone.length === 0">
        Please enter your phone number.
      </span>
      <span v-else>
        {{ formattedPhone }}
      </span>
    </div>
    <div class="check-in-phone__keyboard">
      <div id="numericInput"></div>
    </div>
    
    <v-dialog
      v-model="isLoading"
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Please stand by searching for your profile
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- MOVE TO APP.vue/SnackBar component with store -->
    <v-snackbar
      v-model="showSnackbar"
      :color="snackbarState"
      :timeout="snackbarTimeout"
      vertical>
      {{ snackbarText }}
      <v-btn
        dark
        flat
        @click="showSnackbar = false">
        Close
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { NumericKeyboard, keys } from 'numeric-keyboard' // vanilla js version
import clientService from '@/framework/client/clientService'

import Scheduler from '@/views/scheduler/index.vue'

export default {
  components: {
    Scheduler
  },
  data: () => {
    return {
      isLoading: false,
      numericInput: undefined,
      phone: '',
      showSnackbar: false,
      snackbarState: 'primary',
      snackbarText: undefined,
      snackbarTimeout: 0 // zero keeps it open
    }
  },
  computed: {
    formattedPhone () {
      let result = `(${this.phone.substr(0, 3)})`
      if (this.phone.length > 3) {
        result = `${result} ${this.phone.substr(3, 3)}`
      }
      if (this.phone.length > 6) {
        result = `${result}-${this.phone.substr(6, 4)}`
      }
      return result
    }
  },
  mounted () {
    // reset values
    this.$store.commit('checkIn/resetCheckIn')

    var self = this
    this.numericInput = new NumericKeyboard('#numericInput', {
      layout: 'tel',
      theme: {
        global: {
          color: '#808080',
          backgroundColor: ['#ffffff', '#909090'], // specify a pair of colors for active pseudo class
          padding: '5px'
        },
        key: {
          [keys.ENTER]: {
            color: '#ffffff',
            backgroundColor: ['#03a9f4', '#0051a8']
          }
        }
      },
      onClick (key) {
        console.log(key)
      },
      onPress (key) {
        if (key === 'enter') {
          self.findClient()
        } else if (key === 'del') {
          self.removeLastDigit()
        } else {
          self.addDigit(key)
        }
      }
    })
  },
  methods: {
    addDigit (key) {
      if (this.phone.length < 10) {
        this.phone += key
      } else if (this.phone.length === 10) {
        this.openSnackbar('You attempted one too many numbers. Please verify your phone number and press enter. Thank you!', 'error')
      }
    },
    findClient () {
      if (this.phone.length === 10) {
        this.$store.commit('checkIn/updatePhone', this.phone)
        this.isLoading = true

        let query = {
          phone: this.phone
        }

        // get client details via phone number. Then direct them to the selector page
        // if the user had one than more profile based on their appoitnment
        // if the user only has one profile then we send them directly to the client page
        clientService.searchByPhone(query).then(res => {
          if (res.data) {
            this.$store.commit('checkIn/updateClients', res.data)
          }
          this.isLoading = false
          this.$router.push('in/client')
        }).catch(() => {
          this.openSnackbar('There was an issue searching appointments', 'error')
          this.isLoading = false
        })
      }
    },
    removeLastDigit () {
      this.phone = this.phone.slice(0, -1)
    },
    openSnackbar (message, type) {
      this.snackbarState = type
      this.snackbarText = message

      this.showSnackbar = true

      setTimeout(() => {
        if (this.showSnackbar) {
          this.showSnackbar = false
          this.snackbarState = 'primary'
          this.snackbarText = undefined
        }
      }, 6000)
    }
  }
}
</script>

<style lang="scss">
.check-in-phone {
  &__input {
    font-size: 3em;
    font-weight: bold;
    height: 150px;
    text-align: center;
    width: 90vw;
  }

  &__keyboard {
    margin: 0;
    text-align: center;
  }
}
</style>
